var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInfoBadge = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "#FFC72C"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M13.2 18h-2.4v-7.2h2.4zm0-9.6h-2.4V6h2.4z"
})));
export { SvgInfoBadge as ReactComponent };
export default "/_next/static/images/info-badge.svg";